import { GET_ORG_SETTINGS, UPDATE_ORG_SETTINGS } from '../../types'
import { trackPromise } from 'react-promise-tracker'
import log from 'loglevel'
const api = (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'http:' ? 'http://' + window.location.hostname + ':3080' : (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'https:' ? 'https://' + window.location.hostname + ':8443' : process.env.REACT_APP_API_URL

export const getOrgSettings = () => {
  return async function (dispatch, getState) {
    const { token, accountId } = getState().auth

    const options = {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    }
    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/settings`, options))

    if (!response.status || response.status === 401) {
      log.warn('non 200 status code from account settings')
    } else {
      const { data } = await response.json()
      dispatch({
        type: GET_ORG_SETTINGS,
        payload: { ...data }
      })
    }
  }
}

export const updateOrgSettings = (settings) => {
  return async function (dispatch, getState) {
    const { token, accountId } = getState().auth

    const body = { ...settings }

    const options = {
      method: 'PUT',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/settings`, options))

    if (!response.status || response.status === 401) {
      console.error('Error: Failed to update organizational settings.')
    } else {
      const orgSettings = { ...settings }
      dispatch({
        type: UPDATE_ORG_SETTINGS,
        payload: orgSettings
      })
    }
  }
}
